'use client'

import JsCookie from 'js-cookie'

// Types
import type { CookieAttributes } from '@/types/helpers/cookies'

// Get a cookie/localStorage value
const get = (name: string): string | undefined => {
	// Use js-cookie for web
	return JsCookie.get(name)
}

// Set a cookie/localStorage value
const set = (name: string, value: string, options?: CookieAttributes): string | undefined => {
	// Use js-cookie for web
	return JsCookie.set(name, value, options)
}

// Remove a cookie/localStorage value
const remove = (name: string, options?: CookieAttributes): void => {
	// Use js-cookie for web
	JsCookie.remove(name, options)
}

// Export a Cookies object with the same API as js-cookie
const Cookies = { get, set, remove }

export default Cookies
